module.exports = __webpack_public_path__ + "static/media/user.c5be7f17.png";